import { useEffect, useState } from "react";

type ProcessedImage =
  | { status: "loading"; url: null }
  | { status: "ready"; url: string }
  | { status: "error"; url: null };

export function useProcessedImage(src: string, process: (src: string) => Promise<string>): ProcessedImage {
  const [state, setState] = useState<ProcessedImage>({ status: "loading", url: null });

  useEffect(() => {
    let cancelled = false;
    setState({ status: "loading", url: null });
    process(src)
      .then((url) => {
        if (!cancelled) setState({ status: "ready", url });
      })
      .catch(() => {
        if (!cancelled) setState({ status: "error", url: null });
      });
    return () => {
      cancelled = true;
    };
  }, [src, process]);

  return state;
}
